module.exports = __webpack_public_path__ + "img/symbol_13.6aac44b1.png";